import React from "react";
import PropTypes from "prop-types";
import FileSaver from "file-saver";
import { Grid } from "@material-ui/core";
import { Description as DescriptionIcon } from "@material-ui/icons";
import { translate as t } from "../../translate/localization";

import useStyles from "./styles";
import EmptyDataForTableMessage from "../../../app/components/modals/employee/DeleteEmployeesModal/components/EmptyDataForTableMessage";
import TableDataSpinner from "../../../app/components/modals/employee/DeleteEmployeesModal/components/TableDataSpinner";
import Table from "../../../app/components/Table";
import CobeeButton from "../../../app/components/CobeeButton";
import { downloadFile } from "../../repository/public-requests-repository";
import approveRentingRequest from "../../../usecases/requests/approve-renting-request";
import denyRentingRequest from "../../../usecases/requests/deny-renting-request";
import { showErrorMessage } from "../../../usecases/commons/show-error-message";

const COLUMNS = [
  {
    id: "description",
    label: t("request-section.vehicle-model"),
  },
  {
    id: "employeeName",
    label: t("common-messages.employee"),
  },
  {
    id: "documents",
    label: t("common-messages.documents"),
  },
  {
    id: "actions",
    align: "center",
    label: t("common-messages.actions"),
  },
];

function RentingRequestsTable({ requests, isLoading }) {
  const { fileIcon, actionButton, actionsColumn } = useStyles();

  if (isLoading) {
    return <TableDataSpinner />;
  }
  if (!isLoading && requests.length === 0) {
    return <EmptyDataForTableMessage />;
  }

  const handleDownload = async (title, fileId) => {
    try {
      const { data } = await downloadFile({ fileId });
      FileSaver(data, title);
    } catch (e) {
      showErrorMessage(t("common-messages.basic-error-message"));
    }
  };

  return (
    <Grid item xs={12} container>
      <Table
        columns={COLUMNS}
        data={requests.map(
          ({ requestId, description, employee, stepAnswers }) => ({
            description,
            employeeName: `${employee.name} ${employee.surname}`,
            documents: stepAnswers
              .filter(({ file }) => file !== null)
              .map(({ file }) => {
                const { fileId, filename } = file;
                return (
                  <CobeeButton
                    styleType="uncontained"
                    key={fileId}
                    onClick={async () => {
                      await handleDownload(filename, fileId);
                    }}
                  >
                    <DescriptionIcon className={fileIcon} />
                    {filename}
                  </CobeeButton>
                );
              }),
            actions: (
              <Grid
                item
                xs={12}
                container
                justify="center"
                className={actionsColumn}
              >
                <CobeeButton
                  styleType="primary"
                  className={actionButton}
                  onClick={() => approveRentingRequest({ requestId })}
                >
                  {t("actions.approve")}
                </CobeeButton>
                <CobeeButton
                  styleType="primary"
                  className={actionButton}
                  onClick={() => denyRentingRequest({ requestId })}
                >
                  {t("actions.deny")}
                </CobeeButton>
              </Grid>
            ),
          })
        )}
      />
    </Grid>
  );
}

RentingRequestsTable.defaultProps = {
  isLoading: false,
  requests: [],
};

RentingRequestsTable.propTypes = {
  isLoading: PropTypes.bool,
  requests: PropTypes.array,
};

export default RentingRequestsTable;
